import Flash from "../../images/newDesign/flash.svg";

export const storeMock = [
    {
        icon: Flash,
        title: 'שירות לדוגמא 1',
        paragraphs: [
            'עלון על השירות ניתן למצוא https://bllink-public.s3.amazonaws.com/systemsCheckBrochure.jpg',
            'פסקה דוגמא 1',
            'פסקה דוגמא 2',
            'פסקה דוגמא 3',
        ],
        contactPhone: '050-0000000',
        id: 1,
    },
    {
        icon: Flash,
        title: 'שירות לדוגמא 1',
        paragraphs: [
            'עלון על השירות ניתן למצוא https://bllink-public.s3.amazonaws.com/systemsCheckBrochure.jpg',
            'פסקה דוגמא 1',
            'פסקה דוגמא 2',
            'פסקה דוגמא 3',
        ],
        contactPhone: '050-0000000',
        id: 2,
    },
    {
        icon: Flash,
        title: 'שירות לדוגמא 1',
        paragraphs: [
            'עלון על השירות ניתן למצוא https://bllink-public.s3.amazonaws.com/systemsCheckBrochure.jpg',
            'פסקה דוגמא 1',
            'פסקה דוגמא 2',
            'פסקה דוגמא 3',
        ],
        contactPhone: '050-0000000',
        id: 3,
    }
]
